import { Action } from '@ngrx/store';

export type metadataState = {
  isSignalRUpdate: boolean
  correlationId: string | null
  actionType: string
}
export const metadataReducer = (state: metadataState = {
  isSignalRUpdate: false,
  correlationId: null,
  actionType: 'INIT'
}, props: Action & any): metadataState => {
  return ({
    ...state,
    actionType: props.type,
    isSignalRUpdate: props?.signalRUpdate ?? false,
    correlationId: props?.correlationId ?? null,
  });
}
